module.exports = __webpack_public_path__ + "media/images/undraw/matching/data_trends-e488dd1c4c417e28e960d35ec5c088fc.png";